import { render, staticRenderFns } from "./GnbMenu.vue?vue&type=template&id=15d5f248&scoped=true&"
import script from "./GnbMenu.vue?vue&type=script&lang=js&"
export * from "./GnbMenu.vue?vue&type=script&lang=js&"
import style0 from "./GnbMenu.vue?vue&type=style&index=0&id=15d5f248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5f248",
  null
  
)

export default component.exports